/**
 * Affiliate attribution — shared, client-safe constants.
 *
 * Kept free of any server-only imports so it can be used in both browser
 * (React hooks/components) and server (loaders/actions) code.
 */

/**
 * Opaque ref tokens we are willing to persist/forward. Constraining the
 * charset/length keeps the value safe to embed in Stripe metadata, cookies and
 * URLs, and prevents abuse.
 */
export const AFFILIATE_REF_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export function isValidAffiliateRef(value: string | null | undefined): value is string {
    return typeof value === 'string' && AFFILIATE_REF_PATTERN.test(value);
}
